import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'order-ahead.request-profile-completion-popup.title': {
    id: 'order-ahead.request-profile-completion-popup.title',
    defaultMessage: 'Complete Your Profile to Unlock Order Ahead',
    description: 'Title in popup to request user profile completion for order ahead',
  },
  'order-ahead.request-profile-completion-popup.description': {
    id: 'order-ahead.request-profile-completion-popup.description',
    defaultMessage: "To place orders ahead of time, we'll need a few details.",
    description: 'description in popup to request user profile completion for order ahead',
  },
  'order-ahead.request-profile-completion-popup.confirm-button-text': {
    id: 'order-ahead.request-profile-completion-popup.confirm-button-text',
    defaultMessage: "Let's Go!",
    description: 'Confirmation button text in popup to request user profile completion for order ahead',
  },
});
